import { Component, ChangeDetectionStrategy, inject, OnInit } from '@angular/core';
import { TranslationScopes } from '@app/shared/configs/translation-scopes.config';
import { UserFacade } from '@app/store/user';
import { DisclosureService } from '..';
import { environment } from '@env/environment';
import { RouterLink } from '@angular/router';
import { Configurator3DButtonComponent } from '../components/configurator-3d-btn/configurator-3d-btn.component';
import { MetalOrderBtnComponent } from '../components/metal-order-btn/metal-order-btn.component';
import { Badge } from 'primeng/badge';
import { Button } from 'primeng/button';
import { Tooltip } from 'primeng/tooltip';
import { UserInfoComponent } from '../components/user-info/user-info.component';
import { AsyncPipe, DecimalPipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        RouterLink,
        Configurator3DButtonComponent,
        MetalOrderBtnComponent,
        Badge,
        Button,
        Tooltip,
        UserInfoComponent,
        AsyncPipe,
        DecimalPipe,
        TranslatePipe,
    ],
})
export class HeaderComponent implements OnInit {
    private readonly userFacade = inject(UserFacade);
    private readonly disclosureService = inject(DisclosureService);
    readonly metalOrderEnabled = environment.metalOrders.enabled;
    readonly invoiceState$ = this.userFacade.invoiceState$;

    translationScope: string = TranslationScopes.header.scope;
    materialState$ = this.userFacade.materialState$;
    disclosure$ = this.disclosureService.disclosure$;
    logoImage = environment.logo.header.src;
    logoAlt = environment.logo.header.alt;
    logoStyle = environment.logo.header.style;
    demo = environment.demo.enabled;

    private readonly rolesCanInvoicesRead = ['ROLE_CHAIN_STORE_MANAGER'];
    private readonly rolesCanBuyMetals = ['ROLE_CHAIN_STORE_MANAGER', 'ROLE_ADMIN', 'ROLE_SUPER_ADMIN'];

    ngOnInit(): void {
        if (this.hasChainStoreManagerRole) {
            this.userFacade.getUnpaidInfo();
        }
    }

    get hasChainStoreManagerRole(): boolean {
        const userRoles = this.userFacade.permissions.roles;
        return userRoles.some((role) => this.rolesCanInvoicesRead.includes(role));
    }

    get canBuyMetals(): boolean {
        const userRoles = this.userFacade.permissions.roles;
        return userRoles.some((role) => this.rolesCanBuyMetals.includes(role));
    }
}
